import { Flex, Text } from "@chakra-ui/react";
import { ITraderWhoReacted as ITraderWhoReactedInfo } from "src/api/client/news/news-traders-reactions.api.types";
import { WfLinkGhost } from "src/components/base/wf-link";
import { TraderAvatar } from "src/components/common/trader-avatar";
import { getUnderlyingPricePredictionReactionBarOptions } from "src/components/user-reactions/config";
import { useGetUserName } from "src/hooks/use-get-user-name";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface ITraderWhoReacted {
    traderInfo: ITraderWhoReactedInfo;
}

const TRADER_WHO_REACTED_TEST_ID = "trader-who-reacted";

export const TraderWhoReacted = ({ traderInfo }: ITraderWhoReacted) => {
    const { trader, wikifolioShortDescription, wikfolioSymbol, value } = traderInfo;

    const getUserName = useGetUserName();

    const { buildTraderProfileLink, buildWikifolioLink } = useLinkBuilder();
    const traderProfileLink = buildTraderProfileLink(trader.nickName);
    const wikifolioLink = buildWikifolioLink(wikfolioSymbol);

    const pricePredictionOptions = getUnderlyingPricePredictionReactionBarOptions().find(option => option.value === value);

    return (
        <Flex data-test-id={TRADER_WHO_REACTED_TEST_ID}>
            <TraderAvatar flexShrink={0} size="md" trader={trader} mr={1} href={traderProfileLink} />
            <Flex flexDir="column" flexGrow={1} overflow="hidden">
                <WfLinkGhost href={wikifolioLink} fontSize="md" noOfLines={1} wordBreak="break-all">
                    {wikifolioShortDescription}
                </WfLinkGhost>
                <WfLinkGhost href={traderProfileLink} fontWeight="normal" fontSize="sm" noOfLines={1} wordBreak="break-all">
                    {getUserName(trader)}
                </WfLinkGhost>
            </Flex>
            <Text flexShrink={0} alignSelf="center" pl={1} color={pricePredictionOptions?.backgroundColor} fontWeight="semibold">
                {pricePredictionOptions?.text}
            </Text>
        </Flex>
    );
};
